export default __webpack_public_path__ + "static/media/lanka1.5cc20ad1.png";